



































import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import TransactionsTable from "../components/TransactionsTable.vue";
import {TransactionFilter} from "@/model/transaction-filter";

@Component({
  components: {TransactionsTable}
})
export default class Transactions extends Vue {

  transactionsFilter: TransactionFilter = new TransactionFilter();
  activeFilter: TransactionFilter = new TransactionFilter();
  modal = false

  onSearch() {
    this.activeFilter = this.transactionsFilter;
  }
}
